import { useHandoffStatsQuery } from 'hooks/useHandoffStat';
import { useHandoffNotifications } from 'hooks/useHandoffNotifications';
import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { HandoffStats } from 'types/notificationStats';
import { HANDOFF_INBOX_ENABLED } from 'config/features';

interface HandoffContextValue {
  stats: HandoffStats | null;
  isLoading: boolean;
  isError: boolean;
}

const HandoffContext = createContext<HandoffContextValue | undefined>(undefined);
export function HandoffProvider({ children }: { children: ReactNode }) {
  const { data, isLoading, isError } = useHandoffStatsQuery({ enabled: HANDOFF_INBOX_ENABLED });
  useHandoffNotifications(HANDOFF_INBOX_ENABLED);

  const value = useMemo<HandoffContextValue>(
    () => ({
      stats: data ?? null,
      isLoading,
      isError,
    }),
    [data, isLoading, isError],
  );

  return <HandoffContext.Provider value={value}>{children}</HandoffContext.Provider>;
}

export function useHandoffStat() {
  const ctx = useContext(HandoffContext);
  if (!ctx) {
    throw new Error('useHandoffStats must be used within handoffprovider');
  }
  return ctx;
}
